import { sendApplyLicenseEvent } from '../index';
import { EventAdapter } from './EventAdapter';

export class LicenseApplyEventAdapter extends EventAdapter {
  protected intercomEventKey = 'apply-license';
  protected amplitudeEventFunction = sendApplyLicenseEvent;

  constructor(withPurchase: boolean) {
    super();
    try {
      this.eventData = {
        method: withPurchase ? 'purchase' : 'enter_key',
      };
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}
